<template>
  <div class="grant-access">
    <div class="access">
      <div class="access__left">
        <div class="access__title">Cards</div>
        <div class="access__caption">
          This grants merchants access to Card Payment services
        </div>
      </div>
      <div class="access__right">
        <label class="switch">
          <input
            type="checkbox"
            :checked="allows.cardPayments"
            @click="toggleCheckbox('cardPayments')"
          />
          <div class="slider round"></div>
        </label>
      </div>
    </div>
    <div class="action" v-if="!loadingCards">
      <button class="btn btn--primary" @click="() => grantAccess()">
        Save Changes
      </button>
    </div>
    <div class="action" v-else>
      <button class="btn btn--primary" style="opacity: 0.3">Loading...</button>
    </div>
    <div class="access border-divider">
      <div class="access__left">
        <div class="access__title">QR</div>
        <div class="access__caption">
          This grants merchants access to QR services
        </div>
      </div>
      <div class="access__right">
        <label class="switch">
          <input
            type="checkbox"
            :checked="allows.QRPayments"
            @click="toggleCheckbox('QRPayments')"
          />
          <div class="slider round"></div>
        </label>
      </div>
    </div>
    <div class="action" v-if="!loadingQR">
      <button class="btn btn--primary" @click="() => grantQRAccess()">
        Save Changes
      </button>
    </div>
    <div class="action" v-else>
      <button class="btn btn--primary" style="opacity: 0.3">Loading...</button>
    </div>
    <div class="access border-divider">
      <div class="access__left">
        <div class="access__title">Lien</div>
        <div class="access__caption">
          This places/removes a lien on merchant's account
        </div>
      </div>

      <div class="profile__right">
        <div v-if="$store.state.activeLien">
          <p class="">Amount</p>
          <div class="access__caption">
            {{ $store.state.activeLien.amount }}
          </div>

          <p class="">Reason</p>
          <div class="access__caption">
            {{ $store.state.activeLien.reason }}
          </div>
        </div>
        <div v-else>
          <div class="form__item">
            <label class="form__label" for>Amount</label>
            <input class="form__input" v-model="lien.amount" type="number" />
            <span class="attention" v-if="$v.lien.amount.$error"
              >Field can't be empty</span
            >
          </div>

          <div class="form__item">
            <label class="form__label" for>Reason</label>
            <input
              autocomplete="off"
              v-model="lien.reason"
              class="form__input"
              type="text"
            />
            <span class="attention" v-if="$v.lien.reason.$error"
              >Field can't be empty</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="action">
      <button
        v-if="!$store.state.activeLien"
        class="btn btn--primary"
        @click="() => placeLien()"
      >
        {{ loading ? "Loading..." : "    Save Changes" }}
      </button>
      <button v-else class="btn btn--primary" @click="() => removeLien()">
        {{ loading ? "Loading..." : " Remove Lien" }}
      </button>
    </div>
    <div class="border-divider-button"></div>
  </div>
</template>

<script>
const CARD_PAYMENT_TYPE_ID = "16";
const QR_PAYMENT_TYPE_ID = "17";

import Vue from "vue";
import { required } from "vuelidate/lib/validators";
import { computed } from "@vue/composition-api";
export default {
  name: "AccessControl",
  data() {
    return {
      lien: {},
      loading: false,
      loadingCards: false,
      loadingQR: false,
      allows: {
        cardPayments: false,
        QRPayments: false,
      },
    };
  },
  async mounted() {
    await this.$store.dispatch("getMerchantAccess", this.$route.params.id);
    await this.$store.dispatch("listMerchantLien", this.$route.params.id);
    // await this.$store.dispatch("listAllLien");
    if (this.$store.state.merchantAccess[this.$route.params.id]) {
      this.allows.cardPayments =
        this.$store.state.merchantAccess[this.$route.params.id][
          CARD_PAYMENT_TYPE_ID
        ];
    }
    if (this.$store.state.merchantAccess[this.$route.params.id]) {
      this.allows.QRPayments =
        this.$store.state.merchantAccess[this.$route.params.id][
          QR_PAYMENT_TYPE_ID
        ];
    }
  },
  validations: {
    lien: {
      amount: {
        required,
      },
      reason: {
        required,
      },
    },
  },
  methods: {
    toggleCheckbox(property) {
      this.allows[property] = !this.allows[property];
      this.$emit("setCheckboxVal", this.allows[property]);
    },
    async grantAccess() {
      try {
        this.loadingCards = true;
        const requestData = {
          merchantId: this.$route.params.id,
          transactionTypeId: CARD_PAYMENT_TYPE_ID,
          adminEnabled: this.allows.cardPayments,
          merchant_enabled: this.allows.cardPayments,
        };
        const res = await Vue.http.post(
          `dashboard/admin/merchant_service_access`,
          requestData
        );
        this.$notify({
          group: "notifications-default",
          type: "success text-white",
          title: "Success",
          text: res.body.message,
        });
      } catch (error) {
        console.log(error);
        this.loadingCards = false;
        this.$notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: error.body.message ? error.body.message : "An error occurred",
        });
      }
    },

    async grantQRAccess() {
      try {
        this.loadingQR = true;
        const requestData = {
          merchantId: this.$route.params.id,
        };
        const res = await Vue.http.post(
          `admin/nqr/merchant/activate`,
          requestData
        );
        this.loadingQR = false;
        this.$notify({
          group: "notifications-default",
          type: "success text-white",
          title: "Success",
          text: res.body.message,
        });
      } catch (error) {
        this.loadingQR = false;
        this.$notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: error.body.message ? error.body.message : "An error occurred",
        });
      }
    },
    async placeLien() {
      this.loading = true;
      this.$v.lien.$touch();
      if (this.$v.lien.$invalid) {
        return;
      }
      await this.$store.dispatch("adminPlaceLien", {
        merchantId: this.$route.params.id,
        ...this.lien,
      });
      this.$v.lien.$reset();
      this.lien = {};
      this.loading = false;
    },
    async removeLien() {
      this.loading = true;
      await this.$store.dispatch("adminRemoveLien", {
        merchantId: this.$route.params.id,
      });
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.access {
  display: flex;
  justify-content: space-between;
  padding: 48px 98px;

  .access__title {
    color: #261940;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 16px;
  }
  .access__caption {
    color: rgba(#261940, 0.8);
    max-width: 267px;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 32px;
  }
  .access__right {
    display: flex;
    align-items: center;
    // background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #261940;
    border-radius: 100px;
    // padding: 12px 18px;
    &.toggle-danger {
      .toggleWrapper {
        background: #e90c0c !important;
      }
      .toggle__text {
        color: #e90c0c !important;
      }
    }

    .access-granted {
      background: #67d495 !important;
    }

    .toggleWrapper {
      background: red;
      border-radius: 20px;
      padding: 1px;
      height: 20px;
      width: 35px;
    }
    &__text {
      color: #67d495;
      margin-left: 5px;
      font-size: 14px;
    }
    &__display {
      font-size: 12px;
      font-weight: 600;
      margin-right: 8px;
    }
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 26px;
  }

  .switch input {
    display: none;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e90c0c;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #67d495;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #67d495;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
}
.space-down {
  margin-bottom: 32px;
}
.border-divider {
  border-top: 4px solid #ebf0f4;
  margin-right: 0 !important;
}

.border-divider-button {
  border-top: 1px solid #ebf0f4;
}

.profile {
  border-bottom: none !important;
}

.action {
  padding: 30px 98px 30px 0;
  text-align: right;
}
</style>
